import { FormEvent, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { api } from "../../api/client";
import { AlertBanner } from "../../components/feedback/AlertBanner";
import { TurnstileWidget } from "../../components/auth/TurnstileWidget";
import { AuthLayout } from "../../components/layout/AuthLayout";
import { Field } from "../../components/forms/Field";
import { apiError } from "../../lib/apiError";

const SUCCESS_MESSAGE =
  "Jeśli konto z tym adresem istnieje, wysłaliśmy link do resetu hasła. Sprawdź skrzynkę e-mail.";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [turnstileEnabled, setTurnstileEnabled] = useState(false);
  const [turnstileSiteKey, setTurnstileSiteKey] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");

  useEffect(() => {
    if (!navigator.onLine) {
      return;
    }
    let cancelled = false;
    (async () => {
      const result = await api.GET("/api/auth/config");
      if (cancelled || result.error) {
        return;
      }
      const data = result.data as {
        turnstile_enabled?: boolean;
        turnstile_site_key?: string;
      };
      setTurnstileEnabled(Boolean(data.turnstile_enabled));
      setTurnstileSiteKey(data.turnstile_site_key || "");
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    const result = await api.POST("/api/auth/forgot-password", {
      body: { email: email.trim(), captcha_token: captchaToken },
    });
    setBusy(false);
    if (result.error) {
      setError(apiError(result.error, "Nie udało się wysłać wiadomości."));
      return;
    }
    setDone(true);
  }

  return (
    <AuthLayout
      title="Zapomniane hasło"
      subtitle="Wyślemy link do ustawienia nowego hasła"
    >
      <AlertBanner variant="error" message={error} onDismiss={() => setError(null)} />
      {done ? (
        <>
          <div
            className="app-alert app-alert--ok"
            role="status"
            aria-live="polite"
            data-testid="forgot-success"
          >
            <p className="app-alert__text">{SUCCESS_MESSAGE}</p>
          </div>
          <p className="auth__footer">
            <Link to="/login">Wróć do logowania</Link>
          </p>
        </>
      ) : (
        <>
          <form
            className="auth__form"
            data-testid="forgot-password-form"
            autoComplete="off"
            onSubmit={(event) => void onSubmit(event)}
          >
            <Field label="Adres e-mail">
              <input
                id="email"
                className="input"
                type="email"
                name="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
                autoFocus
                autoComplete="email"
                data-testid="forgot-email"
              />
            </Field>
            {turnstileEnabled && turnstileSiteKey ? (
              <TurnstileWidget
                siteKey={turnstileSiteKey}
                onToken={setCaptchaToken}
                onExpire={() => setCaptchaToken("")}
              />
            ) : null}
            <button
              className="btn btn--block"
              type="submit"
              disabled={
                busy ||
                Boolean(turnstileEnabled && turnstileSiteKey && !captchaToken)
              }
              data-testid="forgot-submit"
            >
              Wyślij link resetujący
            </button>
          </form>
          <p className="auth__footer">
            <Link to="/login">Wróć do logowania</Link>
          </p>
        </>
      )}
    </AuthLayout>
  );
}
